<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="replacementBills/getOffsetList"
        @update:filter="reset">
      <div slot="toolbar">
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="关键字">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
          <vm-search label="冲账日期">
            <el-date-picker
                v-model="offsetDate"
                :picker-options="pickerOptions"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="offsetDateChange"/>
          </vm-search>
          <vm-search label="项目号">
            <el-input v-model.trim="filter.faultSerialNO" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column
          fixed="left"
          prop="billNo"
          width="140"
          align="center"
          label="售后单号">
        <template slot-scope="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</span>
          <el-button
              v-clipboard="scope.row.billNo"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
              round
              icon="el-icon-chat-line-square"/>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" label="客户名称" align="center" width="120"/>
      <el-table-column prop="materialNo" label="SAP物料代码" align="center" width="100"/>
      <el-table-column prop="materialDesc" label="名称型号规格" align="center" width="200"/>
      <el-table-column prop="mainPartsSerialNo" label="变频器序列号" align="center" width="200"/>
      <el-table-column prop="quantity" label="数量" align="center" width="80"/>
      <el-table-column prop="offsetNum" label="已冲账数" align="center"/>
      <el-table-column prop="offsetStatus" label="冲账状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.offsetStatus === 1">
            已冲账
          </span>
          <!--						<span v-else-if="scope.row.offsetStatus === 2">-->
          <!--							部分冲账-->
          <!--						</span>-->
          <span v-else>
            未冲账
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="backNo" label="退回单号" align="center" width="100"/>
      <el-table-column fixed="right" label="实物冲账" align="center" width="270">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction: row;align-items: center">
            <span style="display: block;width: 90px">退回数量：</span>
            <el-input v-model="scope.row.backNum" size="mini" type="text" @change="submitNum(scope.row)"/>
          </div>
          <div style="display: flex;flex-direction: row;align-items: center;margin: 10px 0">
            <span style="display: block;width: 79px">退回日期：</span>
            <el-date-picker
                v-if="scope.row.offsetTime !== null"
                v-model="scope.row.offsetTime"
                size="mini"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
                style="width:auto"
            />
            <el-date-picker
                v-else
                size="mini"
                :v-model="getFormatDate(scope.row)"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
                style="width:auto"
            />
          </div>
          <div style="display: flex;flex-direction: row;align-items: center">
            <span style="display: block;width: 90px">退回单号：</span>
            <el-input v-model="scope.row.backNo" size="mini" type="text"/>
          </div>
          <div style="text-align: right">
            <el-button
                v-if="scope.row.offsetStatus !== 1 && editAuth && scope.row.backNum > 0"
                :disabled="!scope.row.backNo"
                size="mini"
                @click="offsetSubmitBySH(scope.row)">
              提交
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="订单冲账" align="center" width="270">
        <template slot-scope="scope">
          <div style="display: flex;flex-direction: row;align-items: center">
            <span style="display: block;width: 90px">订单号：</span>
            <el-input v-model="scope.row.offsetOrderNo" size="mini" type="text"/>
          </div>
          <div style="display: flex;flex-direction: row;align-items: center;margin: 10px 0">
            <span style="display: block;width: 80px">订单数量：</span>
            <el-input v-model="scope.row.offsetOrderNum" size="mini" type="text" @change="submitNum(scope.row)"/>
          </div>
          <div style="text-align: right">
            <el-button
                v-if="scope.row.offsetStatus !== 1 && editAuth"
                :disabled="scope.row.offsetOrderNo === '' || scope.row.offsetOrderNo == null"
                size="mini"
                @click="offsetSubmitByDD(scope.row)"
            >
              提交
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="冲账记录" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="$refs.revise.open(scope.row.pkid)">查看</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="firstHandleTime" label="首次处理时间" align="center" width="130"/>
    </vm-table>
    <replacement-edit ref="editPage" @save-success="getList(1)"/>
    <replacement-export-edit ref="exportPage"/>
    <bill-task-revise ref="revise"/>
  </div>
</template>


<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ReplacementEdit from "@/views/afterSalesManagement/Replacement/ReplacementEdit";
  import ReplacementExportEdit from "@/views/afterSalesManagement/Replacement/ReplacementExportEdit";
  import loginUtil from "@/util/loginUtil";
  import BillTaskRevise from "@/views/afterSalesManagement/BillTask/BillTaskRevise";

  export default {
    name: "TaskList",
    components: {BillTaskRevise, ReplacementExportEdit, ReplacementEdit, VmTable, VmSearch},
    data() {
      return {
        idList: "",
        currentId: loginUtil.getUserId(),
        editAuth: this.$auth(899),
        exportLoading: false,
        offsetDate: "",
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        filter: {
          filter: "",
          beginOffsetDate: "",
          endOffsetDate: "",
          faultSerialNO: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      clipboardSuccessHandler(e) {
        this.$message.success("复制单号成功");
      },
      clipboardErrorHandler(e) {
        this.$message.error("复制单号失败");
      },
      offsetDateChange(date) {
        if (date !== null) {
          this.filter.beginOffsetDate = date[0];
          this.filter.endOffsetDate = date[1];
        } else {
          this.filter.beginOffsetDate = "";
          this.filter.endOffsetDate = "";
        }
      },
      reset() {
        this.offsetDate = "";
        this.filter.beginOffsetDate = "";
        this.filter.endOffsetDate = "";
        this.filter.filter = "";
        console.log(this.filter);
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "replacementBills/exportByCZ", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      copyBillNo(billNo) {
        this.$copyText(billNo).then(function(e) {
          alert("success");
          console.log(e);
        }, function(e) {
          alert("Can not copy");
          console.log(e);
        });
      },
      goto(row) {
        this.$router.push({
          path: "/Replacement",
          query: {
            billType: 13,
            billId: row.masterId,
            $tabName: row.billNo,
          },
        });
      },
      offsetSubmitBySH(row) {
        if (row.backNum > row.quantity) {
          this.$message.error("退回数量不可大于实际数量:" + row.quantity);
        } else {
          row.offsetType = 0;
          this.$http.post("basic", "replacementBills/offsetSubmit", row).then(() => {
            this.$message.success("提交成功");
            this.getList(1);
          });
        }
      },
      submitNum(row) {
        if (row.backNum > row.quantity) {
          return this.$message.error("退回数量不可大于实际数量:" + row.quantity);
        }
        if (row.offsetOrderNum > row.quantity) {
          return this.$message.error("订单数量不可大于实际数量:" + row.quantity);
        }
      },
      offsetSubmitByDD(row) {
        if (row.offsetOrderNum > row.quantity) {
          this.$message.error("订单数量不可大于实际数量:" + row.quantity);
        } else {
          row.offsetType = 1;
          this.$http.post("basic", "replacementBills/offsetSubmit", row).then(() => {
            this.$message.success("提交成功");
            this.getList(1);
          });
        }
      },
      //获取当前时间
      getFormatDate(row) {
        let date = new Date();
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        if (hours >= 0 && hours <= 9) {
          hours = "0" + hours;
        }
        if (minutes >= 0 && minutes <= 9) {
          minutes = "0" + minutes;
        }
        if (seconds >= 0 && seconds <= 9) {
          seconds = "0" + seconds;
        }
        row.offsetTime = date.getFullYear() + "-" + month + "-" + strDate + " " + hours + ":" + minutes + ":" + seconds;
      },
    },
  };
</script>

<style scoped>

</style>
